
export const SWITCH_THEME_MODE = 'SWITCH_THEME_MODE';

export const shitchThemeMode = (mode = 'light') => ({
	type: SWITCH_THEME_MODE,
  mode: mode
});
